import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { DexMultiTileModel, DexResponse, DexSingleTileModel } from 'models/common/ads-types';

import { MesoDexMultiTile } from 'components/meso/meso-destination-experience/dex-multi-tile';
import { MesoDexSingleTile } from 'components/meso/meso-destination-experience/dex-single-tile';

export const MesoDestinationExperience: React.FunctionComponent = () => {
  const [dexTileModel, setDexTileModel] = React.useState<DexMultiTileModel | DexSingleTileModel>();

  React.useEffect(() => {
    window.meso = window.meso || {};
    window.meso.destinationExperience = window.meso.destinationExperience || [];
    window.addEventListener('mesoDEXLoaded', onLoad);
    window.meso.destinationExperience.push(true);
  }, []);

  function onLoad(e) {
    if (!e || !e.detail || !e.detail.data || !e.detail.data.type) {
      return;
    }

    const detail = (e as DexResponse).detail;
    const { data } = detail;
    setDexTileModel(data);
  }

  return (
    <ErrorBoundary label="meso.destination-experience">
      <li data-stid="meso-dex">
        {dexTileModel?.type === 'multi' && <MesoDexMultiTile {...(dexTileModel as DexMultiTileModel)} />}
        {dexTileModel?.type === 'single' && <MesoDexSingleTile {...(dexTileModel as DexSingleTileModel)} />}
      </li>
    </ErrorBoundary>
  );
};
MesoDestinationExperience.displayName = 'MesoDestinationExperience';
